/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerParentProjection } from './PartnerParentProjection';
import {
    PartnerParentProjectionFromJSON,
    PartnerParentProjectionFromJSONTyped,
    PartnerParentProjectionToJSON,
    PartnerParentProjectionToJSONTyped,
} from './PartnerParentProjection';
import type { Title } from './Title';
import {
    TitleFromJSON,
    TitleFromJSONTyped,
    TitleToJSON,
    TitleToJSONTyped,
} from './Title';

/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {number}
     * @memberof Contact
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    mobile: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    _function: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    isSigner: boolean;
    /**
     * 
     * @type {PartnerParentProjection}
     * @memberof Contact
     */
    parentId?: PartnerParentProjection | null;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    crmBusinessProvider: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    comment: string;
    /**
     * 
     * @type {Title}
     * @memberof Contact
     */
    title: Title | null;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): value is Contact {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('_function' in value) || value['_function'] === undefined) return false;
    if (!('isSigner' in value) || value['isSigner'] === undefined) return false;
    if (!('crmBusinessProvider' in value) || value['crmBusinessProvider'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function ContactFromJSON(json: any): Contact {
    return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): Contact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'phone': json['phone'],
        'mobile': json['mobile'],
        '_function': json['function'],
        'isSigner': json['is_signer'],
        'parentId': json['parent_id'] == null ? undefined : PartnerParentProjectionFromJSON(json['parent_id']),
        'crmBusinessProvider': json['crm_business_provider'],
        'active': json['active'],
        'type': json['type'],
        'comment': json['comment'],
        'title': TitleFromJSON(json['title']),
    };
}

export function ContactToJSON(json: any): Contact {
    return ContactToJSONTyped(json, false);
}

export function ContactToJSONTyped(value?: Contact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'function': value['_function'],
        'is_signer': value['isSigner'],
        'parent_id': PartnerParentProjectionToJSON(value['parentId']),
        'crm_business_provider': value['crmBusinessProvider'],
        'active': value['active'],
        'type': value['type'],
        'comment': value['comment'],
        'title': TitleToJSON(value['title']),
    };
}

